/** Ceiling for the published PDF, in bytes — mirrored by the graph layer and the company service. */
export const MAX_QUOTE_ARTIFACT_BYTES = 15 * 1024 * 1024;

export type PublishBlockedReason = 'PDF_TOO_LARGE';

export type PublishPreparation = {ok: true; file: File} | {ok: false; reason: PublishBlockedReason};

/**
 * Size-checks the rendered PDF BEFORE anything leaves the browser. A blocked publish returns a
 * typed reason and touches nothing — the designer state is intact.
 */
export function prepareQuotePublish(pdfBlob: Blob, fileName: string): PublishPreparation {
	if (pdfBlob.size > MAX_QUOTE_ARTIFACT_BYTES) {
		return {ok: false, reason: 'PDF_TOO_LARGE'};
	}
	return {ok: true, file: new File([pdfBlob], fileName, {type: 'application/pdf'})};
}
